import { render } from "./VideoDetailsBookmarkButton.vue?vue&type=template&id=1ec24bb0&ts=true"
import script from "./VideoDetailsBookmarkButton.vue?vue&type=script&lang=ts"
export * from "./VideoDetailsBookmarkButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__